import { Helmet } from "react-helmet";
import { appConfig } from "src/config";

const OG_IMAGE =
  "https://storage.yandexcloud.net/poparce-front/static/ogLogo.png";

interface JsonLdData {
  [key: string]: unknown;
}

interface PageMetaProps {
  title: string;
  description: string;
  path: string;
  jsonLd?: JsonLdData;
}

export const PageMeta = ({
  title,
  description,
  path,
  jsonLd,
}: PageMetaProps) => {
  const baseUrl = appConfig.url.replace(/\/$/, "");
  const canonical = `${baseUrl}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:site_name" content={appConfig.displayName} />
      <meta property="og:locale" content="ru_RU" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify({ "@context": "https://schema.org", ...jsonLd })}
        </script>
      )}
    </Helmet>
  );
};
